import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, baseDelay = 0.15, lineClassName = "" }) => (
  <>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "115%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, delay: baseDelay + i * 0.14, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </>
);

export const Chapter = ({ index, eyebrow, title, copy }) => (
  <div className="mb-12 sm:mb-16">
    <Reveal>
      <div className="flex items-center gap-4">
        <span className="font-mono text-xs tracking-[0.3em] text-steel">{index}</span>
        <span className="h-px flex-1 bg-line" />
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-fog">{eyebrow}</span>
      </div>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-6 font-display text-2xl font-black uppercase leading-[1.05] tracking-tight sm:text-3xl lg:text-4xl">
        {title}
      </h2>
    </Reveal>
    {copy && (
      <Reveal delay={0.16}>
        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-mist sm:text-base">{copy}</p>
      </Reveal>
    )}
  </div>
);
